import 'rp-jquery-select';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

/**
 * Dropdown presentational component
 * React wrapper over rpSelect jquery component
 */
export default class Select extends PureComponent {
    static propTypes = {
        /**
         * List of objects to display as dropdown list
         * Every object is label-value pair
         */
        options: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
        })).isRequired,
        /**
         * Selected value
         */
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        /**
         * Action to perform at select value change
         */
        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        value: '',
    }

    componentDidMount() {
        $(this.selectRef)
            .rpSelect()
            .on('change', this.handleChange);
    }

    componentDidUpdate() {
        $(this.selectRef).trigger('updated.rp.selectDropdown');
    }

    handleChange = ev => this.props.onChange(ev.target.value);

    render() {
        return (
            <select
                ref={(ref) => { this.selectRef = ref; }}
                value={this.props.value}
                onChange={() => null}
            >
                {this.props.options.map(({ label, value }, i) => (
                    <option
                        key={value}
                        className={`option-${i}`}
                        value={value}
                    >
                        {label}
                    </option>
                ))}
            </select>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Common/Select.jsx